// eslint-disable-next-line import/prefer-default-export
export const boolToStr = (bool) => (bool ? 'Yes' : 'No')
